var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.lastSaveDate),expression:"!!lastSaveDate"}]},[_c('loading-overlay',{attrs:{"hidden":!_vm.loading}}),_c('p',[_vm._v(_vm._s(_vm.lastSaveDateString))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }